// extracted by mini-css-extract-plugin
export default {"ticketCard":"TicketCard_ticketCard__kdDEI","bot":"TicketCard_bot__sTaPi"};